import { render, staticRenderFns } from "./OtpPage.vue?vue&type=template&id=a6dce11e&scoped=true"
import script from "./OtpPage.vue?vue&type=script&lang=js"
export * from "./OtpPage.vue?vue&type=script&lang=js"
import style0 from "./OtpPage.vue?vue&type=style&index=0&id=a6dce11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dce11e",
  null
  
)

export default component.exports